<template>
  <slot
    :load="load"
    :dataForm="dataForm"
    :step="step"
    :qNumNeph="qNumNeph"
    :error="error"
    :desac="desac"
    :contract="contract"
    :contractValue="contractValue"
    :informationComp="informationComp"
    :knows="knows"
    :knowsTwo="knowsTwo"
    :dossierPrice="dossierPrice"
    :codePrice="codePrice"
    :conduitePrice="conduitePrice"
    :priceChoice="priceChoice"
    :resultConduitePrice="resultConduitePrice"
    :canTakeHour="canTakeHour"
    :fonc="fonc"
    :agence="agence"
    :social="socialLabel"
    :code="code"
    :contractStatus="contractStatus"
    :lateBtn="lateBtn"
    :ageEleve="ageEleve"
    :codeParentForm="codeParentForm"
    :statutSocial="statutSocial"
    :lycees="lycees"

    :filterFonctionnaliteMontant="filterFonctionnaliteMontant"
    :dateNaissanceFormated="dateNaissanceFormated"
    :checkAllStepOne="checkAllStepOne"
    :checkAllStepTwo="checkAllStepTwo"
    :checkAllStepThree="checkAllStepThree"
    :checkNom="checkNom"
    :checkPrenom="checkPrenom"
    :checkTelParent="checkTelParent"
    :checkMailParent="checkMailParent"
    :checkTelephone="checkTelephone"
    :checkDateNaissance="checkDateNaissance"
    :checkAdresse="checkAdresse"
    :checkCodePostal="checkCodePostal"
    :checkVille="checkVille"
    :checkNeph="checkNeph"
    :checkqNeph="checkqNeph"
    :checkMotifAlcoolStup="checkMotifAlcoolStup"
    :checkDepNaissance="checkDepNaissance"
    :checkVilleNaissance="checkVilleNaissance"
    :checkPaysNaissance="checkPaysNaissance"
    :checkNationaliteFR="checkNationaliteFR"
    :checkParlerFRCouramment="checkParlerFRCouramment"
    :checkPermis="checkPermis"
    :checkVehiculeAmenage="checkVehiculeAmenage"
    :checkFaitSuite="checkFaitSuite"
    :checkPrevoitAac="checkPrevoitAac"
    :checkLunettes="checkLunettes"
    :checkSocial="checkSocial"
    :checkLycee="checkLycee"
    :checkAutreLycee="checkAutreLycee"
    :checkAlreadyHasCode="checkAlreadyHasCode"
    :isLyceen="isLyceen"
    :isAutreLycee="isAutreLycee"
    :checkCode="checkCode"
    :checkBoite="checkBoite"
    :checkConduite="checkConduite"
    :checkForfait="checkForfait"
    :checkInfo="checkInfo"
    :checkInfoTwo="checkInfoTwo"

    :handleChangeNom="handleChangeNom"
    :handleChangePrenom="handleChangePrenom"
    :handleChangeTelephone="handleChangeTelephone"
    :handleChangeNomUsage="handleChangeNomUsage"
    :handleChangeAutrePrenom="handleChangeAutrePrenom"
    :handleChangeDateNaissance="handleChangeDateNaissance"
    :handleChangeAdresse="handleChangeAdresse"
    :handleChangeCodePostal="handleChangeCodePostal"
    :handleChangeVille="handleChangeVille"
    :handleChangeTelParent="handleChangeTelParent"
    :handleChangeMailParent="handleChangeMailParent"
    :handleChangeNumNeph="handleChangeNumNeph"
    :handleChangeQNumNeph="handleChangeQNumNeph"
    :handleChangeDepNaissance="handleChangeDepNaissance"
    :handleChangeVilleNaissance="handleChangeVilleNaissance"
    :handleChangePaysNaissance="handleChangePaysNaissance"
    :handleChangeNationaliteFR="handleChangeNationaliteFR"
    :handleChangeParlerFRCouramment="handleChangeParlerFRCouramment"
    :handleChangePermis="handleChangePermis"
    :handleChangeVehiculeAmenage="handleChangeVehiculeAmenage"
    :handleChangePrevoitAac="handleChangePrevoitAac"
    :handleChangeFaitSuite="handleChangeFaitSuite"
    :handleChangeLunettes="handleChangeLunettes"
    :handleChangeSocial="handleChangeSocial"
    :handleChangeLycee="handleChangeLycee"
    :handleChangeAutreLycee="handleChangeAutreLycee"
    :handleChangeMotifAlcoolStup="handleChangeMotifAlcoolStup"
    :handleChangeBoite="handleChangeBoite"
    :handleChangeForfait="handleChangeForfait"
    :handleChangeAlreadyHasCode="handleChangeAlreadyHasCode"
    :handleChangeContractConduite="handleChangeContractConduite"
    :handleChangeSelectedContrat="handleChangeSelectedContrat"
    :handleChangeSelectedKnows="handleChangeSelectedKnows"

    :goToHome="goToHome"
    :goToPaiement="goToPaiement"
    :goToHomeEleve="goToHomeEleve"
    :late="late"
    :selectHourChange="selectHourChange"
    :changeCodeCbx="changeCodeCbx"
    :changeConduiteCbx="changeConduiteCbx"
    :suivantEtape="suivantEtape"
    :suivantEtape2="suivantEtape2"
    :suivantEtape3="suivantEtape3"
    :signContract="signContract"
    :resendMail="resendMail"
    :cancelStep="cancelStep"
    :sendContratPdf="sendContratPdf"
    :updateCodeSignature="updateCodeSignature"
    :updateCodeSignatureParent="updateCodeSignatureParent"

  />
</template>

<script>
import { mapGetters } from "vuex";
import { useToast } from "primevue/usetoast";

export default {
  name: "FormulairesLogic",
  props: {
    userData: { type: Object },
    showValidation: { type: Boolean },
    isWorking: { type: Boolean },
  },
  computed: {
    ...mapGetters(["permis", "statutSocial", "lycees", "fonctionnalite"]),

    filterFonctionnaliteMontant() {
      if (this.$store.state.fonctionnalite !== null) {
        return this.$store.state.fonctionnalite.filter(
          (el) => el.label === "dossier"
        ).montant;
      }
      return "";
    },

    dateNaissanceFormated() {
      // Si le format de la date est "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      // Quand la date provient de la base de donnée
      if (this.dataForm.dossier.dateNaissance !== undefined && this.dataForm.dossier.dateNaissance.match(/.+[T ]/g) !== null) {
        // Alors conversion en format "yyyy-MM-dd"
        return this.dataForm.dossier.dateNaissance
          .match(/.+[T ]/g)[0]
          .substring(
            0,
            this.dataForm.dossier.dateNaissance.match(/.+[T ]/g)[0].length - 1
          );
      }
      // Sinon la date reste comme elle est
      return this.dataForm.dossier.dateNaissance;
    },

    checkAllStepOne() {
      return (
        this.checkNom &&
        this.checkPrenom &&
        this.checkTelephone &&
        this.checkAdresse &&
        this.checkCodePostal &&
        this.checkVille &&
        this.checkDateNaissance &&
        this.checkTelParent &&
        this.checkMailParent &&
        this.checkqNeph &&
        this.checkNeph
      );
    },

    checkAllStepTwo() {
      return (
        this.checkParlerFRCouramment &&
        this.checkPermis &&
        this.checkVehiculeAmenage &&
        this.checkPrevoitAac &&
        this.checkMotifAlcoolStup &&
        this.checkFaitSuite &&
        this.checkLunettes &&
        this.checkSocial &&
        this.checkNationaliteFR &&
        this.checkPaysNaissance &&
        this.checkVilleNaissance &&
        this.checkDepNaissance &&
        this.checkLycee &&
        this.checkAutreLycee
      );
    },

    checkAllStepThree() {
      return (
        this.checkAlreadyHasCode &&
        this.checkConduite &&
        this.checkInfo &&
        this.checkInfoTwo &&
        this.checkBoite &&
        this.checkForfait
      );
    },

    checkNom() {
      const match = (this.dataForm.nom || "").match(
        /[A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{1,250}/g
      );
      console.log(match, this.dataForm.nom === match[0])
      if (match !== null && match.length === 1) {
        return this.dataForm.nom === match[0];
      }
      return false;
    },

    checkPrenom() {
      const match = (this.dataForm.prenom || "").match(
        /[A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{1,250}/g
      );
      if (match !== null && match.length === 1) {
        return this.dataForm.prenom === match[0];
      }
      return false;
    },

    checkTelParent() {
      const diff =
        Date.now() - new Date(this.dataForm.dossier.dateNaissance).getTime();
      const age = new Date(diff);
      const age_checked = Math.abs(age.getUTCFullYear() - 1970);

      if (age_checked < 18) {
        let match = null;

        if (
          this.dataForm.dossier.telParent !== undefined &&
          this.dataForm.dossier.telParent !== null
        ) {
          match = this.dataForm.dossier.telParent.match(/[0-9]{10}/g);
        }

        if (match !== null && match.length === 1) {
          return this.dataForm.dossier.telParent === match[0];
        }
        return false;
      }
      return true;
    },

    checkMailParent() {
      const diff =
        Date.now() - new Date(this.dataForm.dossier.dateNaissance).getTime();
      const age = new Date(diff);
      const age_checked = Math.abs(age.getUTCFullYear() - 1970);

      if (age_checked < 18) {
        let match = null;
        if (
          this.dataForm.dossier.mailParent !== undefined &&
          this.dataForm.dossier.mailParent !== null
        ) {
          match = this.dataForm.dossier.mailParent.match(
            /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/gm
          );
        }

        if (match !== null && match.length === 1) {
          return this.dataForm.dossier.mailParent === match[0];
        }
        return false;
      }
      return true;
    },

    checkTelephone() {
      const match = (this.dataForm.telephone || "").match(/[0-9]{10}/g);
      if (match !== null && match.length === 1) {
        return this.dataForm.telephone === match[0];
      }
      return false;
    },

    checkDateNaissance() {
      return this.dataForm.dossier.dateNaissance !== "";
    },

    checkAdresse() {
      return this.dataForm.dossier.adresse !== "";
    },

    checkCodePostal() {
      const match = (this.dataForm.dossier.codePostal || "").match(
        /[0-9]{5}|[1-9]{1}[0-9]{3}/g
      );
      if (match !== null && match.length === 1) {
        return this.dataForm.dossier.codePostal === match[0];
      }
      return false;
    },

    checkVille() {
      return this.dataForm.dossier.ville !== "";
    },

    checkNeph() {
      if (this.dataForm.dossier.qNumNeph == "true") {
        return this.dataForm.dossier.numNeph !== "";
      }
      return true;
    },

    checkqNeph() {
      return (
        this.dataForm.dossier.qNumNeph !== null &&
        this.dataForm.dossier.qNumNeph !== "null" &&
        this.dataForm.dossier.qNumNeph !== undefined
      );
    },

    checkMotifAlcoolStup() {
      if (this.dataForm.dossier.faitSuite == "true") {
        return this.dataForm.dossier.motifAlcoolStup !== "null";
      }
      return true;
    },

    checkDepNaissance() {
      if (this.dataForm.dossier.numNeph !== "") return true;
      return (
        this.dataForm.dossier.depNaissance !== undefined &&
        this.dataForm.dossier.depNaissance !== null &&
        this.dataForm.dossier.depNaissance !== ""
      );
    },

    checkVilleNaissance() {
      if (this.dataForm.dossier.numNeph !== "") return true;
      return (
        this.dataForm.dossier.villeNaissance !== undefined &&
        this.dataForm.dossier.villeNaissance !== null &&
        this.dataForm.dossier.villeNaissance !== ""
      );
    },

    checkPaysNaissance() {
      if (this.dataForm.dossier.numNeph !== "") return true;
      return (
        this.dataForm.dossier.paysNaissance !== undefined &&
        this.dataForm.dossier.paysNaissance !== null &&
        this.dataForm.dossier.paysNaissance !== ""
      );
    },

    checkNationaliteFR() {
      if (this.qNumNeph == "false") {
        return this.dataForm.dossier.nationaliteFR !== "null";
      }
      return true;
    },

    checkParlerFRCouramment() {
      return this.dataForm.dossier.parlerFRCouramment !== "null";
    },

    checkPermis() {
      return this.dataForm.dossier.permis !== "null";
    },

    checkVehiculeAmenage() {
      return this.dataForm.dossier.vehiculeAmenage !== "null";
    },

    checkFaitSuite() {
      return this.dataForm.dossier.faitSuite !== "null";
    },

    checkPrevoitAac() {
      return (
        this.dataForm.dossier.prevoitAac !== "null" &&
        this.dataForm.dossier.prevoitAac !== null
      );
    },

    checkLunettes() {
      return this.dataForm.dossier.lunettes !== "null";
    },

    checkSocial() {
      if (
        this.dataForm.dossier.social == null ||
        this.dataForm.dossier.social == "null"
      ) {
        return false;
      }
      return true;
    },

    checkLycee() {
      if (this.isLyceen) {
        return (
          this.dataForm.dossier.lycee !== "null" &&
          this.dataForm.dossier.lycee !== null
        );
      }
      return true;
    },

    checkAutreLycee() {
      if (this.isLyceen && this.dataForm.dossier.lycee === "autre") {
        return this.dataForm.dossier.autreLycee !== "";
      }
      return true;
    },

    isLyceen() {
      if (this.checkSocial && this.statutSocial !== null) {
        for (let i = 0; i < this.statutSocial.length; i++) {
          if (this.statutSocial[i].label === "Lycéen") {
            return (
              "/api/statut_socials/" + this.statutSocial[i].id ===
              this.dataForm.dossier.social
            );
          }
        }
      }
      return false;
    },

    isAutreLycee() {
      return this.isLyceen && this.dataForm.dossier.lycee === "autre";
    },

    checkCode() {
      return this.contractValue.code !== null;
    },

    checkBoite() {
      return this.informationComp.boite !== null;
    },

    checkConduite() {
      return this.contractValue.conduite !== null;
    },

    checkAlreadyHasCode(){
      return this.contractValue.code !== null;
    },

    checkForfait() {
      return (
        this.informationComp.forfait !== null &&
        this.informationComp.forfait !== undefined &&
        this.informationComp.forfait !== "null"
      );
    },

    checkInfo() {
      return this.contractValue.selectedContrat !== null;
    },

    checkInfoTwo() {
      return this.contractValue.selectedKnows !== null;
    },

    socialLabel() {
      if (!this.statutSocial || !this.dataForm.dossier.social) return "";
      const found = this.statutSocial.find(
        (s) => "/api/statut_socials/" + s.id === this.dataForm.dossier.social
      );
      return found ? found.label : "";
    },
  },
  data() {
    return {
      load: 0,
      dataForm: this.userData,
      step: 1,
      qNumNeph: null,
      error: "",
      desac: false,
      contract: null,
      contractValue: {
        code: null,
        conduite: null,
        selectedContrat: null,
        selectedKnows: null,
      },

      informationComp: {
        boite: null,
        forfait: null,
      },

      knows: [        { brand: "Démarrer un véhicule", value: "1" },
        { brand: "Aborder une carrefour à sens giratoire", value: "3" },
        { brand: "Aborder une entrée d'autoroute", value: "2" },
        { brand: "Aucune de ses réponses", value: "0" },
      ],
      knowsTwo: [        { brand: "Allumer tous les feux du véhicule", value: "1" },
        { brand: "Tourner le volant en chevauchant les mains", value: "1" },
        { brand: "Démarrer sur une terrain en cote", value: "1" },
        { brand: "Manipuler les vitesses de 1 à 5", value: "2" },
        { brand: "Aucune de ses réponses", value: "0" },
      ],
      dossierPrice: 0,
      codePrice: 0,
      conduitePrice: 0,
      priceChoice: {
        name: "",
        price: 0,
      },
      resultConduitePrice: 0,
      canTakeHour: false,
      fonc: [],
      agence: [],
      code: "",
      contractStatus: false,
      lateBtn: false,
      ageEleve: 0,
      codeParentForm: "",
      toast: useToast(),
    };
  },
  mounted() {
    this.getFonctionnalite();
    this.getAgence();
  },
  methods: {
    sendContratPdf() {
      window.api
        .get("contract/" + this.$store.state.user.id + "/sendmail", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          this.toast.add({
            severity: "success",
            summary: "Votre contrat a bien été envoyé par mail !",
            detail: "N'oubliez pas de regarder dans vos spams au cas où !",
            life: 3000,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goToHome() {
      window.location.reload();
    },

    goToPaiement(mode) {
      let fonc = this.$store.state.fonctionnalite;
      fonc.push({
        id: 9999999,
        label: this.priceChoice.name,
        montant: this.priceChoice.price,
      });
      this.$store.commit("setFonctionnalite", fonc);

      this.$store.dispatch("startSaveBouton", mode);
      let fonctionnalite = this.priceChoice.name;
      let router = this.$router;
      this.$store.dispatch("endSaveBouton", { mode, fonctionnalite, router });
    },

    goToHomeEleve() {
      window.location.reload();
    },

    late() {
      this.resendMail();
      this.step = this.step + 1;
      this.lateBtn = true;
    },

    selectHourChange(e) {
      this.priceChoice.price = this.priceChoice.price - this.resultConduitePrice;
      let hour = parseInt(e.target.value);
      this.resultConduitePrice = hour * this.conduitePrice;
      this.priceChoice.price = this.priceChoice.price + this.resultConduitePrice;
    },

    changeCodeCbx(e) {
      this.priceChoice.name = "";
      if (e.target.checked) {
        if (!this.$store.state.studentDossier) {
          this.priceChoice.name = this.priceChoice.name + "dossier";
        }

        if (this.priceChoice.name.length == 0) {
          this.priceChoice.name = this.priceChoice.name + "code";
        } else {
          this.priceChoice.name = this.priceChoice.name + ",code";
        }

        if (document.getElementById("conduite") != null) {
          if (
            this.contract.questions == 0 &&
            document.getElementById("conduite").checked
          ) {
            if (this.priceChoice.name.length == 0) {
              this.priceChoice.name = this.priceChoice.name + "conduite";
            } else {
              this.priceChoice.name = this.priceChoice.name + ",conduite";
            }
          }
        }

        this.priceChoice.price = this.priceChoice.price + this.codePrice;
      } else {
        if (!this.$store.state.studentDossier) {
          this.priceChoice.name = "dossier";
        }

        if (document.getElementById("conduite") != null) {
          if (
            this.contract.questions == 0 &&
            document.getElementById("conduite").checked
          ) {
            if (this.priceChoice.name.length == 0) {
              this.priceChoice.name = this.priceChoice.name + "conduite";
            } else {
              this.priceChoice.name = this.priceChoice.name + ",conduite";
            }
          }
        }

        this.priceChoice.price = this.priceChoice.price - this.codePrice;
      }
    },

    changeConduiteCbx(e) {
      this.priceChoice.name = "";
      if (e.target.checked) {
        if (
          this.dataForm.dossier.numNeph == "" &&
          this.$store.state.studentDossier == false
        ) {
          this.priceChoice.name = this.priceChoice.name + "dossier";
        }

        if (
          this.contract.questions == 0 &&
          document.getElementById("codeCbxok").checked
        ) {
          if (this.priceChoice.name.length == 0) {
            this.priceChoice.name = this.priceChoice.name + "code";
          } else {
            this.priceChoice.name = this.priceChoice.name + ",code";
          }
        }

        if (this.priceChoice.name.length == 0) {
          this.priceChoice.name = this.priceChoice.name + "conduite";
        } else {
          this.priceChoice.name = this.priceChoice.name + ",conduite";
        }

        this.canTakeHour = true;
      } else {
        if (
          this.dataForm.dossier.numNeph == "" &&
          this.$store.state.studentDossier == false
        ) {
          this.priceChoice.name = this.priceChoice.name + "dossier";
        }

        if (
          this.contract.questions == 0 &&
          document.getElementById("codeCbxok").checked
        ) {
          if (this.priceChoice.name.length == 0) {
            this.priceChoice.name = this.priceChoice.name + "code";
          } else {
            this.priceChoice.name = this.priceChoice.name + ",code";
          }
        }

        this.canTakeHour = false;
        this.priceChoice.price =
          this.priceChoice.price - this.resultConduitePrice;
        this.resultConduitePrice = 0;
      }
    },

    getAgence() {
      window.api
        .get("/agences/" + this.$store.state.user.agence.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.agence = response.data;
          this.load = this.load + 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFonctionnalite() {
      window.api
        .get("/fonctionnalites/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.fonc = response.data["hydra:member"];
          response.data["hydra:member"].forEach((fonc) => {
            if (fonc.label === "dossier") {
              this.dossierPrice = fonc.montant;
            } else if (fonc.label === "code") {
              this.codePrice = fonc.montant;
            } else if (fonc.label === "conduite") {
              this.conduitePrice = fonc.montant;
            }
          });
          this.getContract();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getContract() {
      window.api
        .get("/contract/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.contract = response.data;

          if (this.contract.contractEleve != undefined) {
            if (this.contract.contractEleve[0].piece != undefined) {
              if (this.contract.contractEleve[0].piece.status == "valide") {
                this.contractStatus = true;
              }
            }
          }
          if (this.$store.state.user.dateInsc == "null") {
            this.step = 1;
          } else {
            if (
              this.dataForm.dossier.adresse == "" ||
              this.dataForm.dossier.adresse === undefined
            ) {
              this.step = 1;
              this.dataForm.dossier.social = "null";
              this.dataForm.dossier.parlerFRCouramment = "true";
              this.dataForm.dossier.permis = "/api/permis/3";
              this.dataForm.dossier.vehiculeAmenage = "null";
              this.dataForm.dossier.prevoitAac = "null";
              this.dataForm.dossier.faitSuite = "null";
              this.dataForm.dossier.motifAlcoolStup = "null";
              this.dataForm.dossier.lunettes = "null";
              this.dataForm.dossier.nationaliteFR = "true";
            } else if (
              this.dataForm.dossier.adresse != "" &&
              this.dataForm.dossier.social == undefined
            ) {
              this.dataForm.dossier.social = "null";
              this.dataForm.dossier.parlerFRCouramment = "true";
              this.dataForm.dossier.permis = "/api/permis/3";
              this.dataForm.dossier.vehiculeAmenage = "null";
              this.dataForm.dossier.prevoitAac = "null";
              this.dataForm.dossier.faitSuite = "null";
              this.dataForm.dossier.motifAlcoolStup = "null";
              this.dataForm.dossier.lunettes = "null";
              this.dataForm.dossier.nationaliteFR = "true";
              this.step = 2;
              this.desac = true;
            } else if (
              this.dataForm.dossier.social != "null" &&
              this.contract.questions == "null"
            ) {
              this.desac = false;
              this.step = 3;
            } else if (this.contract.questions != "null") {
              this.contractValue.selectedContrat = [];
              this.contractValue.selectedKnows = [];
              if (this.contract.questions == 1) {
                this.contractValue.code = "true";
              }

              if (this.contract.questions == 0) {
                this.contractValue.code = "false";
              }

              this.contractValue.conduite = this.contract.questions[1];

              if (this.contract.questions[2] == 1) {
                this.contractValue.selectedContrat.push({
                  brand: "Démarrer un véhicule",
                  value: "1",
                });
              }

              if (this.contract.questions[3] == 3) {
                this.contractValue.selectedContrat.push({
                  brand: "Aborder une carrefour à sens giratoire",
                  value: "3",
                });
              }

              if (this.contract.questions[4] == 2) {
                this.contractValue.selectedContrat.push({
                  brand: "Aborder une entrée d'autoroute",
                  value: "2",
                });
              }

              if (this.contract.questions[5] == 1) {
                this.contractValue.selectedKnows.push({
                  brand: "Allumer tous les feux du véhicule",
                  value: "1",
                });
              }

              if (this.contract.questions[6] == 1) {
                this.contractValue.selectedKnows.push({
                  brand: "Tourner le volant en chevauchant les mains",
                  value: "1",
                });
              }

              if (this.contract.questions[7] == 1) {
                this.contractValue.selectedKnows.push({
                  brand: "Démarrer sur une terrain en cote",
                  value: "1",
                });
              }

              if (this.contract.questions == 2) {
                this.contractValue.selectedKnows.push({
                  brand: "Manipuler les vitesses de 1 à 5",
                  value: "2",
                });
              }

              if (
                this.contract.questions[2] == 0 &&
                this.contract.questions[3] == 0 &&
                this.contract.questions[4] == 0
              ) {
                this.contractValue.selectedContrat.push({
                  brand: "Aucune de ses réponses",
                  value: "0",
                });
              }

              if (
                this.contract.questions[5] == 0 &&
                this.contract.questions[6] == 0 &&
                this.contract.questions[7] == 0 &&
                this.contract.questions == 0
              ) {
                this.contractValue.selectedKnows.push({
                  brand: "Aucune de ses réponses",
                  value: "0",
                });
              }

              this.step = 4;
              if (this.dataForm.dossier.numNeph == "") {
                const diff =
                  Date.now() -
                  new Date(this.dataForm.dossier.dateNaissance).getTime();
                const age = new Date(diff);
                const age_checked = Math.abs(age.getUTCFullYear() - 1970);
                this.ageEleve = age_checked;
              }

              if (!this.$store.state.studentDossier) {
                this.priceChoice.name = "dossier";
                this.priceChoice.price =
                  this.priceChoice.price + this.dossierPrice;
              }
            }
          }

          this.load = this.load + 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleChangeNom(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.nom = data;
      this.handleChange(userDataTmp);
    },

    handleChangePrenom(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.prenom = data;
      this.handleChange(userDataTmp);
    },

    handleChangeTelephone(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.telephone = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNomUsage(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.nomUsage = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAutrePrenom(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.autresPrenom = data;
      this.handleChange(userDataTmp);
    },

    handleChangeDateNaissance(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.dateNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAdresse(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.adresse = data;
      this.handleChange(userDataTmp);
    },

    handleChangeCodePostal(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.codePostal = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVille(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.ville = data;
      this.handleChange(userDataTmp);
    },

    handleChangeTelParent(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.telParent = data;
      this.handleChange(userDataTmp);
    },

    handleChangeMailParent(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.mailParent = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNumNeph(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.numNeph = data;
      this.handleChange(userDataTmp);
    },

    handleChangeQNumNeph(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.qNumNeph = data;
      if (data === "false") {
        userDataTmp.dossier.numNeph = "";
      }
      this.handleChange(userDataTmp);
    },

    handleChangeDepNaissance(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.depNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVilleNaissance(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.villeNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangePaysNaissance(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.paysNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNationaliteFR(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.nationaliteFR = data;
      this.handleChange(userDataTmp);
    },

    handleChangeParlerFRCouramment(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.parlerFRCouramment = data;
      this.handleChange(userDataTmp);
    },

    handleChangePermis(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.permis = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVehiculeAmenage(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.vehiculeAmenage = data;
      this.handleChange(userDataTmp);
    },

    handleChangePrevoitAac(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.prevoitAac = data;
      this.handleChange(userDataTmp);
    },

    handleChangeFaitSuite(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.faitSuite = data;
      this.handleChange(userDataTmp);
    },

    handleChangeLunettes(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.lunettes = data;
      this.handleChange(userDataTmp);
    },

    handleChangeSocial(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.social = data;
      this.handleChange(userDataTmp);
    },

    handleChangeLycee(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.lycee = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAutreLycee(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.autreLycee = data;
      this.handleChange(userDataTmp);
    },

    handleChangeMotifAlcoolStup(data) {
      let userDataTmp = this.dataForm;
      userDataTmp.dossier.motifAlcoolStup = data;
      this.handleChange(userDataTmp);
    },

    handleChangeBoite(data){
      let userDataTmp = this.informationComp;
      userDataTmp.boite = data;
      this.handleChange(userDataTmp);
    },

    handleChangeForfait(data){
      let userDataTmp = this.informationComp;
      userDataTmp.forfait = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAlreadyHasCode(data){
      let userDataTmp = this.contractValue;
      userDataTmp.code = data;
      this.handleChange(userDataTmp);
    },

    handleChangeContractConduite(data){
      let userDataTmp = this.contractValue;
      userDataTmp.conduite = data;
      this.handleChange(userDataTmp);
    },

    handleChangeSelectedContrat(data){
      let userDataTmp = this.contractValue;
      userDataTmp.selectedContrat = data;
      this.handleChange(userDataTmp);
    },

    handleChangeSelectedKnows(data){
      let userDataTmp = this.contractValue;
      userDataTmp.selectedKnows = data;
      this.handleChange(userDataTmp);
    },


    handleChange(userDataUpdated) {
      this.$emit("update", userDataUpdated);
    },

  

    suivantEtape() {
     
      let check = this.checkAllStepOne;
      if (!check) {
        this.error = "Champ(s) invalide(s) :";
        if (!this.checkNom) {
          this.error += " Nom, ";
        }
        if (!this.checkPrenom) {
          this.error += " Prénom, ";
        }

        if (!this.checkTelephone) {
          this.error += " Téléhpone, ";
        }

        if (!this.checkDateNaissance) {
          this.error += " Date de naissance, ";
        }

        if (!this.checkAdresse) {
          this.error += " Adresse, ";
        }

        if (!this.checkCodePostal) {
          this.error += " Code Postal, ";
        }

        if (!this.checkVille) {
          this.error += " Ville, ";
        }

        if (!this.checkTelParent) {
          this.error += " Téléphone parent, ";
        }

        if (!this.checkMailParent) {
          this.error += " Mail parent, ";
        }

        if (!this.checkqNeph) {
          this.error += " Question numéro Neph, ";
        }

        if (!this.checkNeph) {
          this.error += " Numéro Neph, ";
        }

        this.error += "veuillez changer vos réponses";
      } else {
        let mode = "null";

        let userDataTmp = this.dataForm;
        userDataTmp.dossier.form = 2;
        this.handleChange(userDataTmp);

        this.$emit("saveDossier", mode);

        let userCo = this.$store.state.user;
        userCo.nom = this.userData.nom;
        userCo.prenom = this.userData.prenom;
        this.desac = true;
        this.$store.commit("setUser", userCo);
        this.error = "";
        this.step = this.step + 1;
      }
    },

    suivantEtape2() {
      let check = this.checkAllStepTwo;
      if (!check) {
        this.error = "Champ(s) invalide(s) :";
        if (!this.checkParlerFRCouramment) {
          this.error += " Parler FR, ";
        }
        if (!this.checkPermis) {
          this.error += " Permis demandé, ";
        }

        if (!this.checkVehiculeAmenage) {
          this.error += " Véhicule aménagé, ";
        }

        if (!this.checkPrevoitAac) {
          this.error += " Conduite accompagnée, ";
        }

        if (!this.checkMotifAlcoolStup) {
          this.error += " Motif alcool stup, ";
        }

        if (!this.checkFaitSuite) {
          this.error += " Fait suite à une annulation, ";
        }

        if (!this.checkLunettes) {
          this.error += " Lunettes, ";
        }

        if (!this.checkSocial) {
          this.error += " Status social, ";
        }

        if (!this.checkNationaliteFR) {
          this.error += " Nationalité FR, ";
        }

        if (!this.checkPaysNaissance) {
          this.error += " Pays de naissance, ";
        }

        if (!this.checkVilleNaissance) {
          this.error += " Ville de naissance, ";
        }

        if (!this.checkVilleNaissance) {
          this.error += " Département de naissance, ";
        }

        if (!this.checkLycee) {
          this.error += " Lycée, ";
        }

        if (!this.checkAutreLycee) {
          this.error += " Autre lycée, ";
        }

        this.error += "veuillez changer vos réponses";
      } else {
        let social = this.statutSocial.find(
          (e) => e.id == this.userData.dossier.social.substring(20)
        );

        if (social["label"] == "Lycéen") {
          localStorage.removeItem("lyceen");
          localStorage.setItem("lyceen", "true");
          this.$store.commit("setLyceen", true);
        }

        let userDataTmp = this.dataForm;
        userDataTmp.dossier.form = 3;
        this.handleChange(userDataTmp);

        let mode = "null";
        this.$emit("saveDossier", mode);
        this.error = "";
        this.step = this.step + 1;
        this.desac = false;
      }
    },

    suivantEtape3() {
      if (
        !this.checkAlreadyHasCode ||
        !this.checkConduite ||
        !this.checkInfo ||
        !this.checkInfoTwo ||
        !this.checkBoite ||
        !this.checkForfait
      ) {
        this.error = "Champ(s) invalide(s) :";
        if (!this.checkCode) {
          this.error += " Code, ";
        }
        if (!this.checkConduite) {
          this.error += " Avez-vous conduit, ";
        }

        if (!this.checkInfo) {
          this.error += " Le 1er savez-vous, ";
        }

        if (!this.checkInfoTwo) {
          this.error += " Le 2ème savez-vous, ";
        }

        if (!this.checkBoite) {
          this.error += " Type de boite, ";
        }

        if (!this.checkForfait) {
          this.error += " Forfait, ";
        }

        this.error += "veuillez changer vos réponses";
      } else {
        let questions = [];
        let code = 0;
        if (this.contractValue.code == "true") {
          code = 1;
        }

        questions.push(code);
        questions.push(parseInt(this.contractValue.conduite));

        let findQ1 = false;
        let findQ2 = false;
        let findQ3 = false;

        this.contractValue.selectedContrat.forEach((response) => {
          if (response.brand == "Démarrer un véhicule") {
            findQ1 = true;
          }

          if (response.brand == "Aborder une carrefour à sens giratoire") {
            findQ2 = true;
          }

          if (response.brand == "Aborder une entrée d'autoroute") {
            findQ3 = true;
          }
        });

        if (findQ1) {
          questions.push(1);
        } else {
          questions.push(0);
        }

        if (findQ2) {
          questions.push(3);
        } else {
          questions.push(0);
        }

        if (findQ3) {
          questions.push(2);
        } else {
          questions.push(0);
        }

        let find2Q1 = false;
        let find2Q2 = false;
        let find2Q3 = false;
        let find2Q4 = false;

        this.contractValue.selectedKnows.forEach((response) => {
          if (response.brand == "Allumer tous les feux du véhicule") {
            find2Q1 = true;
          }

          if (
            response.brand == "Tourner le volant en chevauchant les mains"
          ) {
            find2Q2 = true;
          }

          if (response.brand == "Démarrer sur une terrain en cote") {
            find2Q3 = true;
          }

          if (response.brand == "Manipuler les vitesses de 1 à 5") {
            find2Q4 = true;
          }
        });

        if (find2Q1) {
          questions.push(1);
        } else {
          questions.push(0);
        }

        if (find2Q2) {
          questions.push(1);
        } else {
          questions.push(0);
        }

        if (find2Q3) {
          questions.push(1);
        } else {
          questions.push(0);
        }

        if (find2Q4) {
          questions.push(2);
        } else {
          questions.push(0);
        }

        let count = 0;
        questions.forEach((q) => {
          count = count + q;
        });

        let heures = [];
        if (count >= 0 && count <= 3) {
          heures = [25, 35];
        } else if (count > 3 && count <= 7) {
          heures = [15, 25];
        } else if (count > 7) {
          heures = [10, 20];
        }

        const diff =
          Date.now() - new Date(this.dataForm.dossier.dateNaissance).getTime();
        const age = new Date(diff);

        const age_checked = Math.abs(age.getUTCFullYear() - 1970);
        let codeParent = "null";
        if (age_checked < 18) {
          codeParent = Math.floor(Math.random() * 9000 + 1000);
        }

        this.ageEleve = age_checked;

        questions.push(heures);
        if (
          this.contract.questions == "null" ||
          this.contract.questions == undefined
        ) {
          window.api
            .post(
              "/contracts",
              {
                eleve: "/api/utilisateurs/" + this.$store.state.user.id,
                question: questions,
                piece: {
                  status: "En attente",
                  code: Math.floor(Math.random() * 9000 + 1000),
                  codeParent: codeParent,
                  date: "null",
                },
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                },
              }
            )
            .then(() => {
              window.api
                .get("/contract/" + this.$store.state.user.id, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                })
                .then((response) => {
                  let idBoite = 1;
                  if (this.informationComp.boite == "bm") {
                    idBoite = 2;
                  }

                  window.api
                    .patch(
                      "/utilisateur/" + this.$store.state.user.id,
                      {
                        boite: idBoite,
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                          "Content-Type": "application/merge-patch+json",
                        },
                      }
                    )
                    .then(() => {
                      window.api
                        .post(
                          "/setforfait/" + this.$store.state.user.id,
                          {
                            forfait: this.informationComp.forfait,
                          },
                          {
                            headers: {
                              Authorization:
                                "Bearer " + this.$store.state.token,
                              "Content-Type": "application/merge-patch+json",
                            },
                          }
                        )
                        .then(() => {
                          this.contract = response.data;
                          this.error = "";
                          this.desac = true;

                          this.priceChoice.name = "dossier";
                          this.priceChoice.price =
                            this.priceChoice.price + this.dossierPrice;

                          this.confirmContractAndAdvance();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log("ERRR::", error.response.data);
            });
        } else {
          window.api
            .patch(
              "/contracts/" + this.contract.contractEleve[0].id,
              {
                question: questions,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                  "Content-Type": "application/merge-patch+json",
                },
              }
            )
            .then(() => {
              window.api
                .get("/contract/" + this.$store.state.user.id, {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                })
                .then((response) => {
                  let idBoite = 1;
                  if (this.informationComp.boite == "bm") {
                    idBoite = 2;
                  }

                  window.api
                    .patch(
                      "/utilisateur/" + this.$store.state.user.id,
                      {
                        boite: idBoite,
                      },
                      {
                        headers: {
                          Authorization: "Bearer " + this.$store.state.token,
                          "Content-Type": "application/merge-patch+json",
                        },
                      }
                    )
                    .then(() => {
                      window.api
                        .patch(
                          "/dossiers/" + this.$store.state.dossier.id,
                          {
                            forfait: this.informationComp.forfait,
                          },
                          {
                            headers: {
                              Authorization:
                                "Bearer " + this.$store.state.token,
                              "Content-Type": "application/merge-patch+json",
                            },
                          }
                        )
                        .then(() => {
                          this.contract = response.data;
                          this.error = "";
                          this.desac = true;

                          this.confirmContractAndAdvance();
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              this.isWorkingValider = false;
              console.log(error);
            });
        }
      }
    },

    confirmContractAndAdvance() {
      window.api
        .get("/confirm/contract/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          let userDataTmp = this.dataForm;
          userDataTmp.dossier.form = 5;
          this.handleChange(userDataTmp);
          let mode = "null";
          this.$emit("saveDossier", mode);
          this.step = this.step + 1;

          const diff =
            Date.now() -
            new Date(this.dataForm.dossier.dateNaissance).getTime();
          const age = new Date(diff);

          const age_checked = Math.abs(age.getUTCFullYear() - 1970);
          this.ageEleve = age_checked;
        })
        .catch((error) => {
          console.log(error);
        });
    },


    updateCodeSignature(value) {
      this.codeSignature = value;
    },
    
    updateCodeSignatureParent(value) {
      this.codeParentForm = value;
    },

    signContract() {
      if (this.ageEleve >= 18) {
        if (
          parseInt(this.codeSignature) ==
          this.contract.contractEleve[0].piece.code
        ) {
          window.api
            .patch(
              "/contracts/" + this.contract.contractEleve[0].id,
              {
                piece: {
                  status: "valide",
                  code: this.codeSignature,
                  codeParent: "null",
                  date: new Date().toLocaleDateString("fr"),
                },
                annexe: this.$store.state.annexe,
                retract: this.$store.state.retractContract,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                  "Content-Type": "application/merge-patch+json",
                },
              }
            )
            .then(() => {
              this.sendContratPdf();
              this.contractStatus = true;
              this.toast.add({
                severity: "success",
                summary: "Félicitation !",
                detail: "Contrat signé avec succès !",
                life: 3000,
              });

              let userDataTmp = this.dataForm;
              userDataTmp.dossier.form = 5;
              this.handleChange(userDataTmp);
              let mode = "null";
              this.$emit("saveDossier", mode);
            })
            .catch((error) => {
              this.toast.add({
                severity: "error",
                summary: "Erreur !",
                detail:
                  "Veuillez vérifier que vous saisissez le bon code !",
                life: 3000,
              });

              this.isWorkingValider = false;
              console.log(error);
            });
        } else {
          this.toast.add({
            severity: "error",
            summary: "Erreur !",
            detail: "Veuillez vérifier que vous saisissez le bon code !",
            life: 3000,
          });
        }
      } else {
        if (
          parseInt(this.codeSignature) ==
            this.contract.contractEleve[0].piece.code &&
          parseInt(this.codeParentForm) ==
            this.contract.contractEleve[0].piece.codeParent
        ) {
          window.api
            .patch(
              "/contracts/" + this.contract.contractEleve[0].id,
              {
                piece: {
                  status: "valide",
                  code: this.codeSignature,
                  codeParent: this.codeSignatureParentForm,
                  date: new Date().toLocaleDateString("fr"),
                },
                annexe: this.$store.state.annexe,
                retract: this.$store.state.retractContract,
              },
              {
                headers: {
                  Authorization: "Bearer " + this.$store.state.token,
                  "Content-Type": "application/merge-patch+json",
                },
              }
            )
            .then(() => {
              this.contractStatus = true;
              this.sendContratPdf();
              this.toast.add({
                severity: "success",
                summary: "Félicitation !",
                detail: "Contrat signé avec succès !",
                life: 3000,
              });

              let userDataTmp = this.dataForm;
              userDataTmp.dossier.form = 5;
              this.handleChange(userDataTmp);
              let mode = "null";
              this.$emit("saveDossier", mode);
            })
            .catch((error) => {
              this.isWorkingValider = false;
              console.log(error);

              this.toast.add({
                severity: "error",
                summary: "Erreur !",
                detail:
                  "Veuillez vérifier que vous saisissez le bon code !",
                life: 3000,
              });
            });
        } else {
          this.toast.add({
            severity: "error",
            summary: "Erreur !",
            detail: "Veuillez vérifier que vous saisissez le bon code !",
            life: 3000,
          });
        }
      }
    },

    resendMail() {
      window.api
        .get("/confirm/contract/" + this.$store.state.user.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then(() => {
          this.toast.add({
            severity: "success",
            summary: "Le mail a bien été envoyé",
            detail: "N'oubliez pas de regarder dans vos spams au cas où !",
            life: 3000,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cancelStep() {
      if (this.desac) {
        this.desac = false;
      } else {
        this.desac = true;
      }

      this.step = this.step - 1;

      if (this.step == 3) {
        this.desac = false;
      }

      this.priceChoice.price = 0;
      if (this.dataForm.dossier.numNeph == "") {
        this.priceChoice.name = "dossier";
      } else {
        this.priceChoice.name = "";
      }

      this.priceChoice.price = this.dossierPrice + this.priceChoice.price;

      this.error = "";
      this.lateBtn = false;
    },
  },
};
</script>